import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { getCheckoutChrome } from "./schema/checkout-chrome/get-checkout-chrome";
import { advanceHsaGroup } from "./schema/hsa/advance-hsa-group";
import { completeHsaSession } from "./schema/hsa/complete-hsa-session";
import { createHsaSession } from "./schema/hsa/create-hsa-session";
import { finalizeHandoffSurvey } from "./schema/hsa/finalize-handoff-survey";
import { getCurrentHsaGroup } from "./schema/hsa/get-current-hsa-group";
import { getHandoffSurveyGroup } from "./schema/hsa/get-handoff-survey-group";
import { getHandoffSurveyPreviousGroup } from "./schema/hsa/get-handoff-survey-previous-group";
import { rewindHsaGroup } from "./schema/hsa/rewind-hsa-group";
import { submitHsaAnswer } from "./schema/hsa/submit-hsa-answer";

export const rpcDefinition = {
  getCheckoutChrome,
  createHsaSession,
  getCurrentHsaGroup,
  submitHsaAnswer,
  advanceHsaGroup,
  rewindHsaGroup,
  completeHsaSession,
  getHandoffSurveyGroup,
  getHandoffSurveyPreviousGroup,
  finalizeHandoffSurvey,
};

export type CheckoutRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
